import { createTheme } from '@mui/material/styles';

export const createDarkTheme = () => {
	const returnValue = createTheme({
		palette: {
			mode: 'dark',
			background: {
				// default: page background, paper: surfaces — tweak as needed
				default: '#000000',
				paper: '#0b0b0b',
			},
			primary: {
				// ensures focus color picks up a good contrast
				main: '#90caf9',
				light: '#bbdefb',
				dark: '#42a5f5',
			},
		},
	});
	return returnValue;
};
